import { Outlet } from 'react-router';
import { Toaster } from '@/components/atoms/sonner';
import { Navbar } from '@/components/molecules/Navbar';

export default function Layout() {
  return (
    <div>
      {/* Navbar */}
      <Navbar />
      {/* Content */}
      <Outlet />
      <Toaster />
      {/* Footer */}
    </div>
  );
}
